/** Who is holding a thread open, as other agents see them. */
export interface ThreadLockHolder {
	userId: string
	name: string
	imageUrl?: string | null
}

export interface ThreadLock extends ThreadLockHolder {
	threadId: string
}

export interface ThreadLockClaimData {
	workspaceId: string
	threadId: string
	userId: string
	name: string
	imageUrl?: string | null
}

export interface ThreadLockReleaseData {
	workspaceId: string
	threadId: string
	userId: string
}

export interface ThreadLockSubscribeData {
	workspaceId: string
	userId: string
}

/** The full set of held locks, broadcast whenever one is taken or dropped. */
export interface ThreadLockStateData {
	locks: ThreadLock[]
}

/**
 * A held lock survives this long without a refresh, so a closed laptop frees the
 * thread within the window rather than hiding it from the team indefinitely.
 */
export const THREAD_LOCK_TTL_SECONDS = 60

/** Comfortably inside the TTL, so one dropped beat never releases a live lock. */
export const THREAD_LOCK_HEARTBEAT_MS = 20_000
